import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalContainer } from '../../components/ModalContainer';

import { htmlFromMarkdown } from '../../utils/markdown';

import styles from './index.module.css';

interface Props {
  content: string;
}

const SignInSupport: React.FC<Props> = ({ content }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  if (isModalOpen) {
    return (
      <ModalContainer
        isOpen={isModalOpen}
        onModalClose={() => setIsModalOpen(false)}
        component={
          <div
            className={styles.SignInSupportContent}
            dangerouslySetInnerHTML={{
              __html: htmlFromMarkdown(content),
            }}
          ></div>
        }
      />
    );
  }

  return (
    <div className={styles.SignInSupport}>
      <span onClick={() => setIsModalOpen(true)}>
        {t('Need help signing in?')}
      </span>
    </div>
  );
};

export default SignInSupport;
